(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["seo-improvements-hero"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('nrk-carousel')) {
    customElements.define(
      'nrk-carousel',
      class NrkCarousel extends HTMLElement {
        connectedCallback() {
          this.track = this.querySelector('[data-track]');
          if (!this.track) return;
          this.slides = Array.from(this.track.children);
          this.dots = Array.from(this.querySelectorAll('[data-dot]'));
          this.index = 0;
          if (this.slides.length < 2) return;

          this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          this.querySelectorAll('[data-dir]').forEach((button) => {
            button.addEventListener('click', () => this.go(this.index + Number(button.dataset.dir)));
          });
          this.dots.forEach((dot, i) => dot.addEventListener('click', () => this.go(i)));

          this.observer = new IntersectionObserver(
            (entries) => {
              entries.forEach((entry) => {
                if (entry.isIntersecting) this.setActive(this.slides.indexOf(entry.target));
              });
            },
            { root: this.track, threshold: 0.6 }
          );
          this.slides.forEach((slide) => this.observer.observe(slide));

          const seconds = Number(this.dataset.autoplay);
          if (seconds > 0 && !this.reduceMotion) {
            const start = () => {
              this.stop();
              this.timer = setInterval(() => this.go(this.index + 1), seconds * 1000);
            };
            this.addEventListener('mouseenter', () => this.stop());
            this.addEventListener('focusin', () => this.stop());
            this.addEventListener('mouseleave', start);
            this.addEventListener('focusout', start);
            start();
          }
        }

        disconnectedCallback() {
          this.stop();
          if (this.observer) this.observer.disconnect();
        }

        stop() {
          clearInterval(this.timer);
        }

        go(i) {
          const count = this.slides.length;
          const target = ((i % count) + count) % count;
          this.track.scrollTo({ left: target * this.track.clientWidth, behavior: this.reduceMotion ? 'auto' : 'smooth' });
        }

        setActive(i) {
          if (i < 0) return;
          this.index = i;
          this.dots.forEach((dot, j) => dot.setAttribute('aria-current', j === i ? 'true' : 'false'));
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
